module.exports = __webpack_public_path__ + "static/media/UIS-Logo.b695f8dd.png";